<template>

  <v-input v-model="ato.dto.configuracaoRestricao.restricaoVinculadaImovel" :disabled="((!!ato.registro && !edicao) && !ato.legado) || (ato.legado && !edicao) || !edicao"
           type="radio" class="col-6" :default="false"
           label="Criar restrição vinculada apenas ao imóvel?" v-if="mostrar"/>

</template>

<script>

    export default {
        name: "VinculadoImovelRestricao",
        props: {
            ato: {},
            edicao: {default: false}
        },
        computed:{
          mostrar(){
            const opcoes = this.ato.tipoServico?.opcoes;
            if (!opcoes?.permitirRestricaoVinculadaImovel) return false;
            const criarRestricao = opcoes?.criarRestricao || [];
            const restricoesSelecionadas = this.ato.dto?.configuracaoRestricao?.restricoesSelecionadas || [];
            const restricoesAtivas = opcoes?.restricaoOpcional ? restricoesSelecionadas : criarRestricao;
            return restricoesAtivas.includes('ONUS');
          }
        }
    }
</script>
